import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

type CreateFormSheetState = {
  open: boolean
  folderToken: string | null
}

const initialState: CreateFormSheetState = {
  open: false,
  folderToken: null,
}

const createFormSheetSlice = createSlice({
  name: 'createFormSheet',
  initialState,
  reducers: {
    openCreateFormSheet: (state, action: PayloadAction<{ folderToken?: string }>) => {
      state.open = true
      state.folderToken = action.payload.folderToken ?? null
    },
    closeCreateFormSheet: state => {
      state.open = false
      state.folderToken = null
    },
  },
})

export const { openCreateFormSheet, closeCreateFormSheet } = createFormSheetSlice.actions

export default createFormSheetSlice.reducer
